// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3kknI","header":"MergedInvoice_header__3xxs-"};